import React, { useEffect, useState } from "react";
import ConfirmationModal from "./ConfirmationModal.jsx";
import ReassignmentPopover from "./ReassignmentPopover.jsx";
import PullForwardDialog from "../features/pullForward/PullForwardDialog.jsx";

export default function ResultsWorkspaceOverlays({
  closeReassignmentPopover,
  planningMutation,
  pullForwardController,
  reassignmentPopover,
}) {
  const [reassignmentInlineStatus, setReassignmentInlineStatus] = useState(null);

  useEffect(() => {
    setReassignmentInlineStatus(null);
  }, [
    reassignmentPopover?.assignmentId,
    reassignmentPopover?.dispatchPeriod,
    reassignmentPopover?.stepId,
    reassignmentPopover?.stepType,
  ]);

  return (
    <>
      {reassignmentPopover ? (
        <ReassignmentPopover
          anchorElement={reassignmentPopover.anchorElement}
          inlineStatus={reassignmentInlineStatus}
          isOpen={true}
          onClose={() => {
            closeReassignmentPopover({ rerender: true });
          }}
          onReassign={(deliveryId, targetTruckId, compatibility) => {
            planningMutation.requestDeliveryMove({
              deliveryId,
              dispatchPeriod: reassignmentPopover.dispatchPeriod,
              onMutationError({ detailItems, message, title }) {
                setReassignmentInlineStatus({
                  deliveryId,
                  detailItems,
                  message,
                  title,
                  type: "error",
                });
              },
              onMutationStart({ loadingToastContent }) {
                setReassignmentInlineStatus({
                  deliveryId,
                  message: loadingToastContent?.message || "Mise à jour en cours.",
                  title: loadingToastContent?.title || "Réaffectation en cours",
                  type: "loading",
                });
              },
              onMutationSuccess() {
                setReassignmentInlineStatus(null);
                closeReassignmentPopover({ rerender: true });
              },
              ...(compatibility ? { targetCompatibility: compatibility } : {}),
              targetTruckId,
              targetTruckName: compatibility?.truck_name || compatibility?.truck_id || "ce camion",
            });
          }}
          rebuildMode={planningMutation.reassignmentRebuildMode}
          stepId={reassignmentPopover.stepId}
          stepType={reassignmentPopover.stepType}
        />
      ) : null}

      {planningMutation.confirmationDialog ? (
        <ConfirmationModal {...planningMutation.confirmationDialog} />
      ) : null}

      <PullForwardDialog controller={pullForwardController} />
    </>
  );
}
